let service_slider_enabled       = false;
let service_inner_slider_enabled = false;
let service_sliders              = $('.section-floating-card .row');
let service_inner_sliders        = $('.section-vertical-tabs .content-inner');


/**
 * Service Sliders
 */
function service_mobile_sliders_enable(){

  if( ! service_slider_enabled){
    service_sliders.slick({
      dots: true,
      speed: 300,
      center: false,
      arrows: true,
      autoplay: false,
      infinite: false,
      slidesToShow: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      prevArrow: "<span class='left-arrow-mobile'></span>",
      nextArrow: "<span class='right-arrow-mobile'></span>",
    });

    service_slider_enabled = true;
  }
}

function service_mobile_sliders_disable(){
  
  if(service_slider_enabled){
    service_slider_enabled = false;
    service_sliders.slick('unslick');
  }
}


/**
 * Service Inner Sliders
 */
function service_inner_mobile_sliders_enable(){

  if( ! service_inner_slider_enabled){
    service_inner_sliders.slick({
      dots: true,
      speed: 300,
      center: false,
      arrows: true,
      autoplay: false,
      infinite: false,
      slidesToShow: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      prevArrow: "<span class='left-arrow-mobile'></span>",
      nextArrow: "<span class='right-arrow-mobile'></span>",
    });

    service_inner_slider_enabled = true;
  }
}

function service_inner_mobile_sliders_disable(){
  
  if(service_inner_slider_enabled){
    service_inner_slider_enabled = false;
    service_inner_sliders.slick('unslick');
  }
}

export default {
  init() {

    if($(".section-vertical-tabs").length) $("body").addClass("services service-inner");

    // Services Pages
    var is_services_page = $(".security-services.page").length || $(".section-vertical-tabs").length;
    if(is_services_page) {

      $(function () {
        if ($(window).width() <= 738) service_mobile_sliders_enable();
      });

      $(window).resize(function(){
        if($(window).width() <= 738) service_mobile_sliders_enable();
        else service_mobile_sliders_disable();
      });
    }

    // Service Inner (Vertical Tabs)
    var is_service_inner_page = $(".section-vertical-tabs").length;
    if(is_service_inner_page) {

      $(function () {
        if ($(window).width() <= 738) service_inner_mobile_sliders_enable();
      });

      $(window).resize(function(){
        if($(window).width() <= 738) service_inner_mobile_sliders_enable();
        else service_inner_mobile_sliders_disable();
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/services.js